import { Combobox as BaseCombobox } from '@base-ui/react';

import { useItems } from './Combobox.hooks';
import { ComboboxButton, ComboboxChipsButton } from './ComboboxButton';
import { ComboboxGroupLabel } from './ComboboxGroupLabel';
import { ComboboxItem } from './ComboboxItem';
import { ComboboxList } from './ComboboxList';
import { ComboboxRoot } from './ComboboxRoot';

export const Combobox = {
  Root: ComboboxRoot,
  Button: ComboboxButton,
  ChipsButton: ComboboxChipsButton,
  List: ComboboxList,
  Item: ComboboxItem,
  Group: BaseCombobox.Group,
  GroupLabel: ComboboxGroupLabel,
  Collection: BaseCombobox.Collection,
  useItems,
};
